// extracted by mini-css-extract-plugin
export default {"Apps":"Apps_Apps__jvAGl","AppsChild":"Apps_AppsChild__DG7Qg","AppsContainer":"Apps_AppsContainer__6loj-"};